

     <!-- Table Header -->
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%; background-color: #ffffff;" class="mat-elevation-z1">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: center;" class="header-cell center-align"></th>
    </ng-container>

    <!-- Expansion Column -->
    <ng-container matColumnDef="expansion">
      <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: center;" class="header-cell center-align"></th>
    </ng-container>

    <!-- Group Name Column -->
    <ng-container matColumnDef="groupName">
      <th mat-header-cell *matHeaderCellDef style="width: 30%; text-align: start;" class="header-cell left-align">Group Name</th>
    </ng-container>

    <!-- Review Due Date Column -->
    <ng-container matColumnDef="reviewDueDate">
      <th mat-header-cell *matHeaderCellDef style="width: 30%; text-align: center;" class="header-cell left-align">Review Due Date</th>
    </ng-container>

    <!-- Risk Rating Column -->
    <ng-container matColumnDef="riskRating">
      <th mat-header-cell *matHeaderCellDef style="width: 30%; text-align: center;" class="header-cell left-align">Risk Rating</th>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  </table>
  <div class="table-container">
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%; background-color: #ffffff;" class="mat-elevation-z1 ">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="checkbox">
     
   
      <td mat-cell   *matCellDef="let element "  class=" "  style="width: 5%; text-align: center; ">
        
        <mat-checkbox *ngIf="element.groupName != 'No Group'" [(ngModel)]="element.selected" (change)="onGroupCheckboxChange(element, $event)" (click)="$event.stopPropagation()">
        </mat-checkbox>
      </td>
    </ng-container>
   

    <!-- Expansion Column -->
    <ng-container matColumnDef="expansion">
     
      <td mat-cell *matCellDef="let element" style="width: 5%;text-align: center;">
        <mat-icon class="pointer action-cls" title="" (click)="toggleExpand(element)">
          {{ element?.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
        </mat-icon>
      </td>
    </ng-container>

    <!-- Group Name Column -->
    <ng-container matColumnDef="groupName">
    
      <td mat-cell *matCellDef="let element" style="width: 30%; text-align: center;">
        <div style="display: flex; justify-content: start; "  title="{{ element?.groupName }}">
          <mat-icon *ngIf="element.groupName != 'No Group'" class="{{ element.ragStatus?.toLowerCase() }} icon-size p-t-3">circle</mat-icon>
          <div class="wrap-cell">{{ element?.groupName }}</div>
        </div>
      </td>
    </ng-container>



 
     <ng-container matColumnDef="reviewDueDate">
     
      <td mat-cell *matCellDef="let element" style="width: 30%; text-align: center;">
        <div style="display: flex; justify-content: center;"  title="{{ element?.reviewDueDate }}">
        
          <div class="wrap-cell">{{ element?.reviewDueDate }}</div>
        </div>
      </td>
    </ng-container>

      <ng-container matColumnDef="riskRating">
    
      <td mat-cell *matCellDef="let element" style="width: 30%; text-align: center;">
        <div style="display: flex; justify-content: center;"  title="{{ element?.riskRating }}">
        
          <div class="wrap-cell">{{ element?.riskRating }}</div>
        </div>
      </td>
    </ng-container>

    <!-- Header Row -->
    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->

    <!-- Data Row -->
    <tr mat-row  *matRowDef="let row; columns: displayedColumns;  let i = index;"   [ngClass]="getRowClass(i, row)"   ></tr>

    <!-- Expanded Row -->
    <tr class="expanded-row"*matRowDef="let element; columns: ['expandedDetail'] ">
      <td [attr.colspan]="displayedColumns.length" *ngIf="element.expanded" style="padding-left: 8em ;">
        <ng-container *ngIf="element.clientDetails?.length > 0">
          
          <table mat-table [dataSource]="element.clientDetails" style="background-color: #f5f5f5; "  multiTemplateDataRows class="inner-table ml-5">
            <!-- Expansion Client Column -->
            <ng-container matColumnDef="clientCheckbox">
              <th mat-header-cell *matHeaderCellDef style="width: 1%;"></th>
              <td mat-cell *matCellDef="let client" style="width: 1%;">
                <mat-checkbox *ngIf="element.groupName === 'No Group'" [(ngModel)]="client.selected" (change)="onClientCheckboxChange($event ,element,client)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="expansionClient">
              <th mat-header-cell *matHeaderCellDef style="width: 1%;"></th>
              <td mat-cell *matCellDef="let client" style="width: 1%;">
                <mat-icon class="pointer action-cls" title="" (click)="toggleExpand(client)">
                  {{ client?.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                </mat-icon>
              </td>
            </ng-container>

            <!-- Client Name Column -->
            <ng-container matColumnDef="clientName">
              <th mat-header-cell *matHeaderCellDef>Client Name</th>
              <td mat-cell *matCellDef="let client">
                {{ client?.clientName }}</td>
            </ng-container>

        

            <!-- Household Name Column -->
            <ng-container matColumnDef="householdName">
              <th mat-header-cell *matHeaderCellDef>Household Name</th>
              <td mat-cell *matCellDef="let client">{{ client?.householdName }}</td>
            </ng-container>

            <!-- Advisor Team Column -->
            <ng-container matColumnDef="clientAdvisorTeam">
              <th mat-header-cell *matHeaderCellDef>Advisor</th>
              <td mat-cell *matCellDef="let client"><div class="wrap-cell" title="{{client?.clientAdvisorTeam}}{{client?.registeredRep?' ['+client?.registeredRep+']':''}}">{{client?.clientAdvisorTeam}} 
                  <span *ngIf="client?.registeredRep" title="" class="m-l-5 m-r-3">[{{client?.registeredRep}}]</span></div>   </td>
            </ng-container>

            <!-- Market Value Column -->
            <ng-container matColumnDef="clientMarketValue">
              <th mat-header-cell *matHeaderCellDef>Market Value</th>
              <td mat-cell *matCellDef="let client">{{ client?.clientMarketValue | currency:'USD':'symbol':'1.2-2' }}</td>
            </ng-container>

                    <!-- Market Value Column -->
            <ng-container matColumnDef="lastUpdatedDate">
              <th mat-header-cell *matHeaderCellDef> Last Update</th>
              <td mat-cell *matCellDef="let client">  <div class="m-0 p-0 wrap-cell" title="{{client?.lastUpdatedBy}}" style="width: 100%;">{{client?.lastUpdatedBy}}</div>
          <div *ngIf="client.lastUpdatedDate && client.lastUpdatedDate != '1900-01-01T00:00:00'" style="width: 100%;">{{client?.lastUpdatedDate | date : 'MM-dd-y'}}</div></td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let client"> <div class="m-0 p-0" [ngSwitch]="element?.status">
                    <label *ngSwitchCase="'PENDING'">Pending</label>
                    <label *ngSwitchCase="'SUBMITTED'">Submitted</label>
                    <label *ngSwitchCase="'RETURNED-BM'">Returned by DS</label>
                    <label *ngSwitchCase="'CLOSED'">Closed</label>
                  </div></td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="clientColumns"></tr>

            <!-- Data Row -->
            <tr mat-row *matRowDef="let row; columns: clientColumns;"  ></tr>


            <tr class="expanded-row"*matRowDef="let clientDetails; columns: ['acc'] ">
          
              <td [attr.colspan]="clientColumns.length" *ngIf="clientDetails?.expanded" style="padding-left: 8em ;" >
                <ng-container *ngIf="clientDetails.accountDetails?.length > 0">
                  <table mat-table [dataSource]="clientDetails.accountDetails"  style=" background-color: #eeeeee" class="inner-table">
                   
        <!-- Client Name Column -->
        <ng-container matColumnDef="forSpace">
          <th mat-header-cell *matHeaderCellDef style="width: 1%;"></th>
          <td mat-cell *matCellDef="let account" style="width: 1%;"></td>
        </ng-container>
                    <!-- Client Name Column -->
                    <ng-container matColumnDef="accountNumber">
                      <th mat-header-cell *matHeaderCellDef>Account</th>
                      <td mat-cell *matCellDef="let account"><div title="{{account?.registrationDesc}}">
                                <span>{{ account?.accountNumber }}</span> <span *ngIf="account?.registrationType" class="m-l-5 m-r-3">[{{account?.registrationType}}]</span>
                              </div>
                              <div class="m-0 p-0 font-12 overflow-ellipsis act-title" *ngIf="account?.accountName"
            title="{{account?.accountName}}">{{account?.accountName}}</div></td>
                    </ng-container>
        
                    <!-- Household Name Column -->
                    <ng-container matColumnDef="accountName">
                      <th mat-header-cell *matHeaderCellDef>Account Name</th>
                      <td mat-cell *matCellDef="let account">{{ account?.accountName }}</td>
                    </ng-container>
        
                    <!-- Advisor Team Column -->
                    <ng-container matColumnDef="programName">
                      <th mat-header-cell *matHeaderCellDef>Program Name</th>
                      <td mat-cell *matCellDef="let account">{{ account?.programName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="strategyName">
                      <th mat-header-cell *matHeaderCellDef>Strategy Name</th>
                      <td mat-cell *matCellDef="let account">{{ account?.strategyName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="accountMarketValue">
                      <th mat-header-cell *matHeaderCellDef>Account Market Value</th>
                      <td mat-cell *matCellDef="let account"><div class="acct-wd" style="margin-left: 35px;">
                              <span class="">{{ account?.accountMarketValue | currency:'USD': 'symbol' : '1.2-2' }} </span>
                            </div></td>
                    </ng-container>
        
                    <!-- Market Value Column -->
                    <ng-container matColumnDef="agencyCode">
                      <th mat-header-cell *matHeaderCellDef>Market Value</th>
                      <td mat-cell *matCellDef="let account">{{ account?.agencyCode }}</td>
                    </ng-container>

                         <!-- Market Value Column -->
                    <ng-container matColumnDef="riskTolerance">
                      <th mat-header-cell *matHeaderCellDef>Risk Tolerance</th>
                      <td mat-cell *matCellDef="let account">{{ account?.riskTolerance }}</td>
                    </ng-container>
        
                    <!-- Header Row -->
                    <tr mat-header-row *matHeaderRowDef="accountColumns"></tr>
        
                    <!-- Data Row -->
                    <tr mat-row *matRowDef="let client; columns: accountColumns;"></tr>

          </table>
        </ng-container>
      </td>
    </tr>



    <ng-container matColumnDef="acc">
    <td mat-cell *matCellDef="let row"></td>
    </ng-container>
            
          </table>
        </ng-container>
      </td>
    </tr>
    <!-- Column Definition for Expansion Row -->
<ng-container matColumnDef="expandedDetail">
  <td mat-cell *matCellDef="let row"></td>
  </ng-container>
 
  </table>
  <div *ngIf="isNoData" class="error strong m-t-30 alignCenter">No Data Found.</div>

  </div>
  <mat-paginator class="footer" #paginator
  [pageSizeOptions]="[100, 250, 500]"
  [length]=totalData [pageSize]=pageSize
  showFirstLastButtons  (page)="handlePageEvents($event)">
</mat-paginator>

